import { downloadFile } from "@common/api/downloadFile";
import { getSettings } from "@common/settingsProvider";
import { getExportFileName } from "@common/exportFileName";
import { getDisplayedRows } from "@common/tableSearch";
import { ClientFilteredPageView } from "@common/pageView/useClientFilteredPageView";

export interface DisplayedRowsExport<TColumn extends string, TRow extends { id: string }> {
    path: string;
    reportName: string;
    pageView: ClientFilteredPageView<TColumn>;
    columnLabels: Record<TColumn, string>;
    rows: Array<TRow>;
    searchString: string;
    // The keys the table leaves out of its search, so the exported rows are the ones on screen.
    searchExclusions?: Array<keyof TRow>;
}

// Every audit table filters, sorts and searches client-side, so its export sends the on-screen row ids in order and the
// backend re-fetches and formats the values. The report name doubles as the Excel sheet tab, whose naming rules the
// generator enforces; only the filename carries the view, which tells two exports of the same table apart.
export async function exportDisplayedRows<TColumn extends string, TRow extends { id: string }>(options: DisplayedRowsExport<TColumn, TRow>) {
    const { pageView } = options;
    const headers = pageView.renderedColumns.map((column) => ({ header: options.columnLabels[column], column }));
    const rows = getDisplayedRows(options.rows, options.searchString, pageView.sortOrderBy, pageView.sortOrder, undefined, options.searchExclusions).map(
        (row) => row.id
    );

    await downloadFile(`${getSettings().apiBaseUrl}${options.path}`, getExportFileName(`${options.reportName} - ${pageView.savedView!.name}`), "POST", {
        headers,
        rows,
        reportName: options.reportName,
    });
}
